import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';
import { NamedLink } from '../../../../components';

import css from './SectionWhyKidHive.module.css';

// Line icons (24px grid, stroke-only so they take the section's ink color).
const IconReviewed = () => (
  <svg className={css.icon} viewBox="0 0 24 24" role="none">
    <path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);
const IconSecure = () => (
  <svg className={css.icon} viewBox="0 0 24 24" role="none">
    <rect x="5" y="11" width="14" height="9" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
);
const IconRefund = () => (
  <svg className={css.icon} viewBox="0 0 24 24" role="none">
    <path d="M4 12a8 8 0 1 0 2.3-5.6" />
    <path d="M4 4v4h4" />
    <path d="M12 8v4l3 2" />
  </svg>
);
const IconReviews = () => (
  <svg className={css.icon} viewBox="0 0 24 24" role="none">
    <path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8L3.5 9.7l5.9-.9z" />
  </svg>
);

const POINTS = [
  { key: 'reviewed', Icon: IconReviewed },
  { key: 'secure', Icon: IconSecure },
  { key: 'refunds', Icon: IconRefund, link: 'CancellationPolicyPage' },
  { key: 'reviews', Icon: IconReviews },
];

/**
 * Signed-out homepage: "Why parents book on KidHive" -- four trust points (providers reviewed
 * before they're listed, Stripe payments, automatic refunds, reviews from families who booked).
 * The wording deliberately matches the Terms/FAQ: providers are reviewed and verified, which is
 * not an endorsement or a guarantee of credentials. Static content only (SSR-safe).
 *
 * @returns {JSX.Element}
 */
const SectionWhyKidHive = () => (
  <section className={css.root} aria-labelledby="why-kidhive-title">
    <div className={css.card}>
      <h2 id="why-kidhive-title" className={css.title}>
        <FormattedMessage id="SectionWhyKidHive.title" />
      </h2>
      <p className={css.subtitle}>
        <FormattedMessage id="SectionWhyKidHive.subtitle" />
      </p>
      <ul className={css.points}>
        {POINTS.map(({ key, Icon, link }) => (
          <li key={key} className={css.point}>
            <span className={css.iconWrap} aria-hidden="true">
              <Icon />
            </span>
            <div>
              <h3 className={css.pointTitle}>
                <FormattedMessage id={`SectionWhyKidHive.${key}.title`} />
              </h3>
              <p className={css.pointBody}>
                <FormattedMessage id={`SectionWhyKidHive.${key}.body`} />{' '}
                {link ? (
                  <NamedLink name={link} className={css.pointLink}>
                    <FormattedMessage id={`SectionWhyKidHive.${key}.link`} />
                  </NamedLink>
                ) : null}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default SectionWhyKidHive;
